import BaseDrawer from '@/components/BaseDrawer';
import BaseDialog from "@/components/BaseDialog";

export function previewMaterialModal({ props, cbs }) {
    return new BaseDialog({
      component: ()=>import('./previewMaterialModal.vue'),
      options: {
        width: '600px',
        title: '查看全部素材',
      },
      props,
      cbs,
    })
  }